(function () {
  function initSlider(root) {
    var range = root.querySelector('[data-ss-ba-slider-range]');
    var before = root.querySelector('[data-ss-ba-slider-before]');
    var handle = root.querySelector('[data-ss-ba-slider-handle]');
    if (!range || !before) return;

    function update() {
      var value = Number(range.value);
      before.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
      if (handle) handle.style.left = value + '%';
    }

    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  }

  function initViewPicker(section) {
    var tabs = section.querySelectorAll('[data-ss-view-tab]');
    var panels = section.querySelectorAll('[data-ss-view-comparison]');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-ss-view-tab') === String(index);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-ss-view-index') === String(index);
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        if (isActive) {
          var slider = panel.querySelector('[data-ss-ba-slider]');
          if (slider) initSlider(slider);
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-ss-view-tab'));
      });
    });
  }

  function initSection(section) {
    section.querySelectorAll('[data-ss-ba-slider]').forEach(initSlider);
    initViewPicker(section);
  }

  function initAll() {
    document.querySelectorAll('.ss-pdp-view-slider-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('.ss-pdp-view-slider-section')
      ? event.target
      : event.target.querySelector('.ss-pdp-view-slider-section');
    if (section) initSection(section);
  });
})();
